import type { InspirationAuthorInfoDTO } from 'autogen/swagger/all';
import { ByAuthor } from 'autogen/translation-keys/trans-website-articleblock';
import { useTranslation } from 'react-i18next';
import { breakpoint, sizes } from 'variables';
import styled from 'styled-components';
import { FontSize14, FontFontFamilyPrimary } from 'autogen/design-tokens/tokens';
import DateString from './DateString';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';

const Container = styled.div`
    display: flex;
    padding: 20px;
    margin-bottom: 30px;
    margin-top: 30px;
    background-color: #ffffff;
    font-size: ${FontSize14};
    font-family: ${FontFontFamilyPrimary};
    align-items: center;

    ${breakpoint.up(sizes.md)} {
        flex-direction: column;
        justify-content: center;
    }
`;

const TextBlock = styled.p`
    display: block;
    color: #93827c;
    text-align: left;
    margin-bottom: 0;

    ${breakpoint.up(sizes.md)} {
        text-align: center;
    }
`;

export const AuthorImageContainer = styled.div`
    max-width: 80px;
    max-height: 80px;
    flex: 1 1 auto;
    min-width: 1px;
    display: flex;
    align-items: center;
    margin-right: 10px;

    img {
        width: 100%;
        height: auto;
        max-height: initial;
        border-radius: 100%;
    }

    ${breakpoint.up(sizes.md)} {
        max-width: 120px;
        max-height: 120px;
        margin-right: 0;
        margin-bottom: 10px;
    }
`;

export default function AuthorInfo(props: InspirationAuthorInfoDTO) {
    const { image, showDate, name, title } = props;
    const { t } = useTranslation();

    return (
        <Container>
            {image && (
                <AuthorImageContainer>
                    <PictureDeprecated {...image} />
                </AuthorImageContainer>
            )}
            <div>
                <TextBlock>
                    {t(ByAuthor)} {name}
                </TextBlock>
                <TextBlock>{title}</TextBlock>
                <TextBlock>
                    <DateString dateTime={showDate} />
                </TextBlock>
            </div>
        </Container>
    );
}
